export const CITYDEF_DEFINITIONS = "/CityDef/GetAllCityDef"
export const CITYDEF_INSERT = "/CityDef/InsertCityDef"
export const CITYDEF_UPDATE = "/CityDef/UpdateCityDef"
export const CITYDEF_DELETE = "/CityDef/DeleteCityDef"